export default __webpack_public_path__ + "static/media/11.3c53b528.JPG";